/**
 * Contains the keys that, when bound to the window object, close overlays such
 * as modals or dropdowns.
 */
export const keysToCloseDropdownInWindow = ['Escape', 'Esc'];

/**
 * Checks if a given key should close overlays such as modals or dropdowns when
 * bound to the window object.
 */
export const isKeyToCloseDropdownInWindow = (key: string): boolean =>
  keysToCloseDropdownInWindow.includes(key);
